<script setup lang="ts">
import { useRouter } from "vue-router";
//import Lucide from "../../base-components/Lucide";
import { FormattedMenu, linkTo } from "@/components/MainMenu/main-menu";
import {checkTypeOfIcon, substractNameOfIcon} from "@wpmss/ts-icons-helper"

interface MenuProps {
  menu: FormattedMenu;
  formattedMenuState: [
    (FormattedMenu | "divider")[],
    (computedFormattedMenu: Array<FormattedMenu | "divider">) => void
  ];
  level: "first" | "second" | "third" | "last";
  setActiveMobileMenu: (active: boolean) => void;
}

const router = useRouter();
const props = defineProps<MenuProps>();
// eslint-disable-next-line
const [formattedMenu, setFormattedMenu] = props.formattedMenuState;
function goToApp(menu:any, router:any, event: Event) {
  if(menu.subMenu == undefined  || menu.subMenu.length == 0) {
  props.setActiveMobileMenu(false);
  }
  linkTo(menu, router, event);
}
</script>

<template>
  <a
    :class="[
      'h-[50px] flex items-center text-white',
      props.level == 'first' && 'px-6',
      props.level != 'first' && 'px-4',
    ]"
    @click="goToApp(props.menu, router, $event)"
  >
    <div>
      <!-- Mobile menu icon here-->
      <div v-if="props.menu.menu_icon != 'no icon'">
      <font-awesome-icon class="h-7"
        v-if="checkTypeOfIcon(props.menu.rec_menu_icon_parent) == 'FontAwesome'"
        :icon="substractNameOfIcon(props.menu.menu_icon)"
      />
      
      <Lucide  v-if="checkTypeOfIcon(props.menu.rec_menu_icon_parent) == 'Lucide'" :icon="props.menu.menu_icon" class="" />
      <component v-if="checkTypeOfIcon(props.menu.rec_menu_icon_parent) == 'HeroIcon'" :is="props.menu.menu_icon" class="w-9" />
      </div>
    </div>
    <div class="flex items-center w-full ml-3">
      {{ $t(props.menu.title) }}
      <div
        v-if="props.menu.subMenu && props.menu.subMenu.length > 0"
        :class="[
          'transition ease-in duration-100 ml-auto',
          props.menu.activeDropdown && 'transform rotate-180',
        ]"
      >
        <Lucide icon="ChevronDown" class="w-5 h-5" />
      </div>
    </div>
  </a>
</template>
